import { render, staticRenderFns } from "./content-game-action.vue?vue&type=template&id=30ca3ba1&scoped=true&"
import script from "./content-game-action.vue?vue&type=script&lang=js&"
export * from "./content-game-action.vue?vue&type=script&lang=js&"
import style0 from "./content-game-action.vue?vue&type=style&index=0&id=30ca3ba1&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30ca3ba1",
  null
  
)

export default component.exports